import { render, staticRenderFns } from "./TaskNotePopup.vue?vue&type=template&id=b9cc45a6"
import script from "./TaskNotePopup.vue?vue&type=script&lang=ts"
export * from "./TaskNotePopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports